import { DefaultTheme } from "styled-components";

export const myTheme: DefaultTheme = {
  colors: {
    main: "#13a456",
    mainHover: "#18d26e",
    text: "#666",
  },
};
